var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-container"},[_c('p',[_vm._v("Development in Progress")])])
}]

export { render, staticRenderFns }